"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _index = require("../state/index.js");
var _index2 = require("../constants/index.js");
/**
 * @typedef {Object} BrandValues
 * @property {string} fallback - The fallback value to use if the brand-specific value is not available.
 * @property {string} telus - The value specific to the TELUS brand.
 * @property {string} koodo - The value specific to the Koodo brand.
 * @property {string} ngc - The value specific to the NGC system.
 */

/**
 * Retrieves a specific property value based on the provided brand.
 *
 * @param {BrandValues} values - The object containing brand-related values.
 */
var getBrandValue = function getBrandValue(values) {
  var _settingsState$setup$, _values$settingsState;
  var isNGC = ((_settingsState$setup$ = _index.settingsState.setup.adobeLaunch) === null || _settingsState$setup$ === void 0 ? void 0 : _settingsState$setup$.property) === _index2.brandValues.properties.NGC;
  if (values.ngc !== undefined && isNGC) {
    return values.ngc;
  }
  return (_values$settingsState = values[_index.settingsState.setup.brand]) !== null && _values$settingsState !== void 0 ? _values$settingsState : values.fallback;
};
var _default = exports["default"] = getBrandValue;